import { useState } from "react";
import { useDialog } from "app/hook";
import { DialogType } from "app/types";
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { ParentGate } from "features/parent/ParentGate";
import { useShouldShowTrialNotice } from "features/subscription";

const SECTION_WIDTH = 760;
const SECTION_HEIGHT = 100;

export const TrialNoticeSection = () => {
  const play = usePlaySound();
  const handleDialog = useDialog();
  const visible = useShouldShowTrialNotice();
  const [gateVisible, setGateVisible] = useState(false);

  if (!visible) return null;

  const handleOpenGate = () => {
    btnDelay(() => {
      play();
      setGateVisible(true);
    });
  };

  const handleGateClose = () => {
    setGateVisible(false);
  };

  const handleGateConfirm = () => {
    setGateVisible(false);
    handleDialog({ type: DialogType.UNIVERSAL, value: false });
    handleDialog({
      type: DialogType.PARENT_REGISTRATION,
      value: true,
      args: { redirectAfterSuccess: "/parent" },
    });
  };

  return (
    <>
      <div
        className="flex-row-el items-center alpha rounded-xl border-solid border-white border-8 bg-orange-10 shadow-lg gap-3 p-2"
        style={{ width: SECTION_WIDTH, height: SECTION_HEIGHT }}
      >
        <div className="flex-col-el flex-center shrink-0 w-14 h-14 rounded-xl bg-orange-100">
          <span className="material-symbols-outlined type-title text-white">
            notification_important
          </span>
        </div>

        <div className="flex-col-el items-start justify-between flex-1 min-w-0 h-14">
          <p className="type-text type-body text-textcolor-black !text-left leading-tight w-full">
            {I18n.t("MSG_TRIAL_NOTICE_TITLE")}
          </p>
          <p className="type-text type-sm text-gray-100 !text-left leading-tight w-full">
            {I18n.t("MSG_TRIAL_NOTICE_FOR_KIDS")}
          </p>
        </div>

        <button
          type="button"
          onClick={handleOpenGate}
          className="type-inherit-font shrink-0 cursor-pointer rounded-xl border-solid border-white border-4 bg-green-100 px-6 py-3 shadow-md active:opacity-70"
        >
          <p className="type-text type-body text-white">{I18n.t("MSG_TRIAL_NOTICE_CTA")}</p>
        </button>
      </div>

      <ParentGate visible={gateVisible} confirm={handleGateConfirm} close={handleGateClose} />
    </>
  );
};
